import { NetworkStatus } from '@cbridge-utils/network';
import { IRoutingProfileStore, RoutingExecutionType } from './routingProfile.interface';

export const routingProfileInitialState: IRoutingProfileStore = {
  data: {},
  defaultData: {
    executionType: RoutingExecutionType.Abook,
  },
  networkStatus: NetworkStatus.None,
};

export const ROUTING_PROFILE_DELAY_MIN = 0;
export const ROUTING_PROFILE_DELAY_MAX = 10000;
